import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../styles/complete_video.scss';

import '../styles/transition-inner-chapter.scss';
import '../styles/transition-group.scss';
import '../styles/mobile_chapter_one.scss';

import Audioelement from './audioelement';
import M_Timeline from './mobile_timeline';
import Shareelement from './shareelement';

class Test extends React.Component{


	constructor(props){
		super(props);

		this.state={
			isPlaying : false,
			activeVideo : 0,
			frameX : 2560,
			frameY : 1440,
			timeInPercentage : 0,
			canplaythrough : false,

			frameAspect : 2560 / 1440,
			windowX : window.innerWidth,
			windowY : window.innerHeight,
			currentChapter : 0,
			audioIsActive : false,
			maxVideo : 1, // switch video on tab
			videoSource : _assets.loaded.completeVideo,
			videoLoadStatus : 0,
			source : null,
		}

		this.play = this.play.bind(this);
		this.pause = this.pause.bind(this);
		this.addHandler();
	}

	componentDidMount(){
		this.setFrameProp();
	}

	setFrameProp(){
		let aspect = this.state.windowX / this.state.windowY;
		if(aspect < this.state.frameAspect){
			this.setState({
				frameX : Math.floor( this.state.windowY * this.state.frameAspect),
				frameY : Math.floor(this.state.windowY)
			});
		}else{
			this.setState({
				frameX : Math.floor( this.state.windowX),
				frameY : Math.floor(this.state.windowX / this.state.frameAspect)
			});
		}
	}

	setFrameSize(){
		this.setState({
			windowX : window.innerWidth,
			windowY : window.innerHeight
		});
		this.setFrameProp();
	}



	touchHandler(){
		let nextVideo = this.state.activeVideo;
				nextVideo = nextVideo >= this.state.maxVideo ? 0 : (nextVideo+=1) ;
		this.setState({
			activeVideo : nextVideo
		});
	}


	addHandler(){

		window.addEventListener('resize', function(){
			this.setFrameSize();
		}.bind(this));

		window.addEventListener('keydown',function(event){
			if(event.keyCode == 32){
				this.touchHandler();
			}
		}.bind(this));

		window.addEventListener('touchstart',function(event){
			this.touchHandler();
		}.bind(this));
	}

	play(){

		console.log('play');
		this.refs.video.play();
		this.setState({
			isPlaying : true
		});
	}

	pause(){
		this.refs.video.pause();
		this.setState({
			isPlaying : false
		})
	}

	prepareVideo(){
		let srcBlob = (window.webkitURL ? webkitURL : URL).createObjectURL(_assets.loaded.completeVideo)
		
		this.setState({
			src : srcBlob
		},function(){
			this.refs.video.addEventListener('timeupdate',function(event){
				this.timeupdate(this.refs.video.currentTime, this.refs.video.duration);
			}.bind(this));
		});		
	}


	timeupdate(timecode,duration){
		
		this.setState({
			timeInPercentage : timecode * 100 / duration
		});

		//console.log(this.state.timeInPercentage, timecode * 100 / duration);
		if(timecode > 0 && timecode < 31.07){
			this.setState({
				currentChapter : 0,
				audioIsActive : false,
				maxVideo : 1
			});
		}
		if(timecode > 31.07 && timecode < 44.09){
			this.setState({
				currentChapter : 1,
				audioIsActive : false,
				maxVideo : 0
			});
		}

		if(this.state.currentChapter != 2 && timecode > 44.09) {
			this.setState({
				isPlaying : false
			})
		}
		if(timecode > 44.09) {
			this.setState({
				currentChapter : 2,
				audioIsActive : true,
				maxVideo : 3
			})
		}

		
	}

	componentWillReceiveProps(nextProps){
	//	console.log(nextProps);
		if(nextProps.firstSession && nextProps.secondSession){
			console.log('ready');
			
			this.prepareVideo();
		}
	}


	chapterSelector(num){

		var chapterTime = 0;
		switch(parseFloat(num)){
			case 0:
				chapterTime = 0;
				this.setState({
					makeAudioActive : false
				});
			break;
			case 1:
				chapterTime = 31.07;
				this.setState({
					makeAudioActive : false
				})
			break;
			case 2:
				chapterTime = 44.09;
				this.setState({
					makeAudioActive : true,
					isPlaying : false
				})
			break;
			default:
				chapterTime = 0;
			break;
		}
		this.refs.video.currentTime = chapterTime;
	}
	skipToChapter(event){
		console.log(event);
		console.log(event.target.dataset.name)
		this.chapterSelector(event.target.dataset.name);
	}

	render(){
		let videoStyle = {
			width : this.state.frameX +'px',
			height : this.state.frameY+'px'
		}

		return (<div className="mobile-frame">
				<div className="helper">
					{this.state.currentChapter} | {this.state.activeVideo}  | {this.props.loadStatus}
				</div>

				<div className={"video-frame active-video-frame-" + this.state.activeVideo}>
					{this.state.currentChapter == 2 && 
						<Audioelement 
							isPlaying = {this.state.isPlaying}
							makeAudioActive={this.state.audioIsActive} />
					}
					<div className="video-frame-container" style={videoStyle}>
						{this.state.src != null && 
							<video autoplay preload="auto" className="video-complete" poster="" playsInline ref="video">
								<source src={this.state.src} type="video/mp4" />
							</video>
						}
					</div>
				</div>

			{/*timeline*/}
			<div className="helper">mobile</div>
				<ReactCSSTransitionGroup
					component= "div"
						className="absolute inner-intro-video mobile"
			      transitionName="fade"
			      transitionAppear={true}
     				transitionAppearTimeout={500}
			      transitionEnterTimeout={500}
			      transitionLeaveTimeout={300}>
			      <nav className="main-nav">
								<div className="main-nav-inner">
									<M_Timeline
										timecode={this.state.timeInPercentage} 
										currentChapter ={this.state.currentChapter}
										skipToChapter={(event)=>this.skipToChapter(event)}
										play={this.play}
										pause={this.pause}
										isPlaying = {this.state.isPlaying}/>
									<Shareelement />
									{/*<ChapterNavi/>*/}
								</div>
						</nav>
						</ReactCSSTransitionGroup>

			</div>);
	}
}


export default Test;


// WEBPACK FOOTER //
// ./src/scripts/test.js